import React, { useEffect, useState } from "react";
import { Clock } from "lucide-react";

function cetParts() {
  const now = new Date();
  const time = new Intl.DateTimeFormat("en-GB", {
    timeZone: "Europe/Budapest", hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: false,
  }).format(now);
  // Determine CET vs CEST label via the short time zone name.
  const tzName = new Intl.DateTimeFormat("en-US", {
    timeZone: "Europe/Budapest", timeZoneName: "short", hour: "2-digit",
  }).formatToParts(now).find((p) => p.type === "timeZoneName")?.value || "";
  const label = tzName.includes("+2") || tzName.includes("CEST") ? "CEST" : tzName.includes("+1") || tzName.includes("CET") ? "CET" : "CET";
  const date = new Intl.DateTimeFormat("en-GB", {
    timeZone: "Europe/Budapest", day: "2-digit", month: "short",
  }).format(now);
  return { time, label, date };
}

export function CentralClock({ className = "" }) {
  const [p, setP] = useState(cetParts());
  useEffect(() => {
    const id = setInterval(() => setP(cetParts()), 1000);
    return () => clearInterval(id);
  }, []);
  return (
    <div data-testid="central-clock" className={`flex items-center gap-2 rounded-full border border-zinc-800 bg-zinc-900/70 px-3 py-1.5 ${className}`}>
      <Clock size={14} className="text-blue-400" />
      <span className="font-mono text-[13px] font-semibold tabular-nums tracking-tight text-zinc-100">{p.time}</span>
      <span className="rounded bg-blue-600/20 px-1.5 py-0.5 text-[10px] font-semibold text-blue-300">{p.label}</span>
      <span className="hidden text-[11px] text-zinc-500 sm:inline">{p.date} · Central European Time</span>
    </div>
  );
}
